<template>
  <DefaultBackground>
    <div class="mt-12 mx-auto flex w-1/3 justify-center">
      <spinner :orange="true" class=""/>
      <span class="text-xl ml-3">Loading, please wait...</span>
    </div>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from '@/components/common/layout/DefaultBackground'
import Spinner from '../../components/common/Spinner.vue'
import api_v1 from '@/api/api_v1.0.js'

export default {
  components: { Spinner, DefaultBackground },
  data () {
    return {
      //
    }
  },

  async created () {
    try {
      console.log('FROM: ', this.$route.query.from)
      const orderResponse = await api_v1.createOrderWithCaterer(this.$route.params.uuid, this.$route.query.from)

      this.$store.commit('setCurrentEditingOrder', orderResponse.data)
      this.$router.push(`/orders/${orderResponse.data.uuid}/edit`)

    } catch (error) {
      this.$router.back()
    }

  },

  methods: {
    //
  }
}
</script>

<style></style>
